import { configureStore } from '@reduxjs/toolkit';
import courseReducer from './redux/slices/courseSlice';
import { CourseLevelApi } from './redux/services/CourseLevelServices';
import { TrainerApi } from './redux/services/TrainerServices';
import { ContentTypeApi } from './redux/services/ContentTypeServices';
import { CategoryApi } from './redux/services/CategoryServices';
import { TagApi } from './redux/services/TagServices';
import { PackageApi } from './redux/services/PackageServices';
import { CourseApi } from './redux/services/CoursesServices';
import { FaqApi } from './redux/services/FaqServices';
import { StoryApi } from './redux/services/StoryServices';
import { SliderApi } from './redux/services/SliderServices';

export default configureStore({
  reducer: {
    course: courseReducer,
    [CourseLevelApi.reducerPath]: CourseLevelApi.reducer,
    [TrainerApi.reducerPath]: TrainerApi.reducer,
    [ContentTypeApi.reducerPath]: ContentTypeApi.reducer,
    [CategoryApi.reducerPath]: CategoryApi.reducer,
    [TagApi.reducerPath]: TagApi.reducer,
    [PackageApi.reducerPath]: PackageApi.reducer,
    [CourseApi.reducerPath]: CourseApi.reducer,
    [StoryApi.reducerPath]: StoryApi.reducer,
    [SliderApi.reducerPath]: SliderApi.reducer,
    [FaqApi.reducerPath]: FaqApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(CourseLevelApi.middleware)
      .concat(TrainerApi.middleware)
      .concat(ContentTypeApi.middleware)
      .concat(TagApi.middleware)
      .concat(CategoryApi.middleware)
      .concat(CourseApi.middleware)
      .concat(PackageApi.middleware)
      .concat(SliderApi.middleware)
      .concat(StoryApi.middleware)
      .concat(FaqApi.middleware),
});
